// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: #fff;
  padding: 28px clamp(24px, 5vw, 56px) 32px;
}

.footer__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.footer__left {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;
  min-width: 0;
}

.footer__nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
}

.footer__nav a,
.footer__legal a {
  color: rgba(44, 24, 16, 0.72);
  font-family: 'Inter', system-ui, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
  text-decoration: none;
  white-space: nowrap;
}

.footer__nav a:hover,
.footer__legal a:hover {
  color: #2c1810;
}

.footer__nav a:focus-visible,
.footer__legal a:focus-visible {
  outline: 2px solid #2c1810;
  outline-offset: 2px;
  border-radius: 2px;
}

.footer__brand {
  color: rgba(44, 24, 16, 0.48);
  font-family: 'Inter', system-ui, sans-serif;
  font-size: 0.875rem;
  line-height: 1.4;
  white-space: nowrap;
}

.footer__legal {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px 20px;
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .footer__inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .footer__legal {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,6BAA6B;EAC7B,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".footer {\n  background: #fff;\n  padding: 28px clamp(24px, 5vw, 56px) 32px;\n}\n\n.footer__inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.footer__left {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 20px;\n  min-width: 0;\n}\n\n.footer__nav {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 16px;\n}\n\n.footer__nav a,\n.footer__legal a {\n  color: rgba(44, 24, 16, 0.72);\n  font-family: 'Inter', system-ui, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.4;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.footer__nav a:hover,\n.footer__legal a:hover {\n  color: #2c1810;\n}\n\n.footer__nav a:focus-visible,\n.footer__legal a:focus-visible {\n  outline: 2px solid #2c1810;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.footer__brand {\n  color: rgba(44, 24, 16, 0.48);\n  font-family: 'Inter', system-ui, sans-serif;\n  font-size: 0.875rem;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n\n.footer__legal {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px 20px;\n  flex-shrink: 0;\n}\n\n@media (max-width: 640px) {\n  .footer__inner {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n  }\n\n  .footer__legal {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
